import { createAction } from 'redux-actions';

export const VERIFY_RECAPTCHA = 'VERIFY_RECAPTCHA';
export const VERIFY_RECAPTCHA_SUCCESS = 'VERIFY_RECAPTCHA_SUCCESS';
export const VERIFY_RECAPTCHA_FAILED = 'VERIFY_RECAPTCHA_FAILED';

export const verifyRecaptcha = createAction(VERIFY_RECAPTCHA);
export const verifyRecaptchaSuccess = createAction(VERIFY_RECAPTCHA_SUCCESS);
export const verifyRecaptchaFailed = createAction(VERIFY_RECAPTCHA_FAILED);